module.exports = __webpack_public_path__ + "static/headphoneamp-c23f0520f0041c2494f567fb4ebfdaa7.jpg";